export default __webpack_public_path__ + "static/media/experts4.d5ce73e8.jpg";